$(function ($) {


  // Isotope
  $(window).on('load',function() {  
    var $grid = $('.gallery-box-wrp').isotope({
      itemSelector: '.gallery-box',
      layoutMode: 'masonry'
    });  
  });

  /*Isotope End*/ 
  

  
 
  
  
  
  
  

  /*---------------- Search Popup ------------------*/

  $(".search-toggle").on('click', function(e) {
    $(".header-section").toggleClass('search-active');
    e.preventDefault();
  });
  // close when click off of container
  $(document).on('click touchstart', function(e) {
    if (!$(e.target).is('.search-toggle, .search-toggle *, .header-section, .header-section *')) {
      $('.search-toggle, .header-section').removeClass('search-active');

    }
  });

  /*---------------- menu toggle ------------------*/

  /*---------------- Mobile Menu ------------------*/
  /*---------------- Responsive Menu ------------------*/
  $(".m-menu-btn").on('click', function (e) {
    $("body").toggleClass('off-canvas-body');
    $(".header-section").toggleClass("menu-open");
    $(this).toggleClass("m-menu-btn-ext");
    e.preventDefault();
  });
  $('nav.menu').on("click", ".has-submenu > a > span", function (e) {
    $(this).parent('a').next('.menu-dropdown').slideToggle(600);
    $(this).toggleClass('icon-down-arrow icon-up-arrow');
    e.stopPropagation();
    e.preventDefault();
  });
  $('nav.menu').on("click", ".has-multisubmenu > a > span", function (e) {
    $(this).parent('a').next('.menu-dropdown').slideToggle(600);
    $(this).toggleClass('icon-down-arrow icon-up-arrow');
    e.stopPropagation();
    e.preventDefault();
  });

  $(document).on('click touchstart', function(e) {
    if (!$(e.target).is('.m-menu-btn, .m-menu-btn , .header-section, .header-section *')) {
      $('.m-menu-btn, .header-section').removeClass('menu-open');
      if ($(".m-menu-btn").hasClass("m-menu-btn-ext")) {
        $(".m-menu-btn").removeClass("m-menu-btn-ext");
      }
    }

  });

  /*----------------footer section ---------------------*/ 

  $('.f-title').on("click", function(e) {
    if ($(this).hasClass('menushow')) {
      remove_styles();
      $(this).removeClass('menushow');
      $(this).next('ul').removeClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').removeClass('menushowtoggle');
      }
    } else {
      remove_styles();
      $(this).addClass('menushow');
      $(this).next('ul').addClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').addClass('menushowtoggle');
      }
    }
    e.stopPropagation();
    e.preventDefault();
  });

  function remove_styles() {
    $('.f-title').each(function() {
      $(this).removeClass('menushow');
      $(this).next('ul').removeClass('menushowtoggle');
      if($(this).next('ul').next('ul').length) {
        $(this).next('ul').next('ul').removeClass('menushowtoggle');
      }
    });
  }



  /*---------------- main Slider ------------------*/

  $('.banner').slick({
    dots: false,
    arrows: true,
    infinite: true, 
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: '10px',
    variableWidth:true,
    slidesToScroll: 1,
    responsive: [

      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 3,
          dots: true,
          arrows: false
        }
      }
    ]
  });

  /* Shop slider */ 
  $('.shop-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.shop-slider-nav'
  });
  $('.shop-slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.shop-slider',
    dots: false,
    arrows: false,
    infinite: false,
    focusOnSelect: true,
    vertical:true,
    verticalSwiping:true,
    responsive: [

      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical:false
          // horizontal:true,


        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical:false
          // horizontal:true,


        }
      },
      { 
        breakpoint:768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical:false,
          verticalSwiping:false
        }
      },
      { 
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical:false
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical:false
        }
      }

    ]
  });

  /* Shop slider end*/ 


  /*---------------- Featured product Slider ------------------*/

  
  /* 
  $('.feature-product-slider').slick({
    dots: false,
    arrows: false,
  
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4
        }
      },

      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4
        }
      },       

      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,          
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  });
  */
  
  /*---------------- Home Our Favorite Slider ------------------*/

  $('.common-product-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5
        }
      },

      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4
        }
      },       

      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  /*----------------Easy Responsive Tab ------------------*/

  $(document).ready(function() {
    //Horizontal Tab
    $('#parentHorizontalTab').easyResponsiveTabs({
      type: 'default', //Types: default, vertical, accordion
      width: 'auto', //auto or any width like 600px
      fit: true, // 100% fit in a container
      tabidentify: 'hor_1', // The tab groups identifier
      activate: function(event) { // Callback function if tab is switched
        var $tab = $(this);
        var $info = $('#nested-tabInfo');
        var $name = $('span', $info);
        $name.text($tab.text());
        $info.show();
      }
    });

  });
  /*----- qty Start --------*/ 

  jQuery(document).ready(function () { 

    $('.qty-btn.plus').click(function (e) {

      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($('input[name=' + fieldName + ']').val());
      // If is not undefined
      if (!isNaN(currentVal)) {
        // Increment
        $('input[name=' + fieldName + ']').val(currentVal + 1);
      } else {
        // Otherwise put a 0 there
        $('input[name=' + fieldName + ']').val(1);
      }
    });
    // This button will decrement the value till 0
    $(".qty-btn.minus").click(function (e) {

      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($('input[name=' + fieldName + ']').val());
      // If it isn't undefined or its greater than 0
      if (!isNaN(currentVal) && currentVal > 1) {
        // Decrement one
        $('input[name=' + fieldName + ']').val(currentVal - 1);
      } else {
        // Otherwise put a 0 there
        $('input[name=' + fieldName + ']').val(1);
      }
    });
    function openTab(event, cityName) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(cityName).style.display = "block";
      event.currentTarget.className += " active";
    }


  });

  /*----- qty End --------*/  
  /*----------------side-barr ------------------*/
  $('.sidebar-content > .title').on("click", function (e) {
    $(this).next('.inner-content').slideToggle(600);
    $(this).toggleClass('open');
    e.stopPropagation();
    e.preventDefault();
  });

  /*Start: Mobile sidebar filters*/
  function filter_popup() {
    $('.mob-filter').magnificPopup({
      delegate: 'a',
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function () {
          this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
      midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
    });

    $('.sidebar-sec').addClass('mfp-hide');
  }
  if ($(window).width() < 1025) {
    filter_popup();
    $('.mfp-content .sidebar-sec').removeClass('mfp-hide');
  }
  $(window).on('resize', function(){
    if ($(window).width() < 1025) {
      filter_popup();
      $('.mfp-content .sidebar-sec').removeClass('mfp-hide');
    }
    else {
      $('.sidebar-sec').removeClass('mfp-hide');
      $('.mfp-content .sidebar-sec').addClass('mfp-hide');
    }
  });


  /*---------------- EQUAL HEIGHT START ------------------*/
  $(window).on('load',function() {
    equalheight('.product-item-block-main');
  //  equalheight('.all-product');
    equalheight('.prod-title');
//    equalheight('.banner-inner-wrap');
  //  equalheight('.best-seller-slider-inner .best-seller-pic');
  });

  $(window).on('resize',function() {
    equalheight('.product-item-block-main');
  //  equalheight('.all-product');
    equalheight('.prod-title');
 //   equalheight('.banner-inner-wrap');
 //   equalheight('.best-seller-slider-inner .best-seller-pic');
  });
  /*---------------- EQUAL HEIGHT END ------------------*/


  /*----------------side-barr ------------------*/
  $('.sidebar-content > .title').on("click", function (e) {
    $(this).next('.inner-content');
    e.stopPropagation();
    e.preventDefault();
  })
  
  $(document).ready(function() {
	$('.gallery-img').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		}
		
	});
});

  

  
  
});

